export const ACTION_PARAM = 'action';
export const MODIFY_EXCHANGE_MODAL = 'modify-exchange-modal';
